import { gql } from "@apollo/client";

export const GET_REQ_CLIENTES_OPTIONS = gql`
query GetRequisitoClienteOptions{
    requisitoClienteOptions
    {
        documentacionRespaldatoria{
          idDocumentacionRespaldatoria
          descripcion
        }
        tipoModulo{
          idTipoModulo
          abreviacion
        }
        presentacionFact{
          idPresentacionFact
          descripcion
        }
        tipoAutorizacion{
          idTipoAutorizacion
          descripcion
        }
        tiempoFacturacion{
          idTmpFact
          descripcion
        }
    }
}`;